import { render } from "./WhatWeDoHome.vue?vue&type=template&id=75365e3e&scoped=true&lang=en"
import script from "./WhatWeDoHome.vue?vue&type=script&lang=js"
export * from "./WhatWeDoHome.vue?vue&type=script&lang=js"

import "./WhatWeDoHome.vue?vue&type=style&index=0&id=75365e3e&scoped=true&lang=scss"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75365e3e"]])

export default __exports__